/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Saving_LabelInputs */



/**
* | output |
* | --- |
* | "Saving..." |
*
* @param {Explorer_Info_Saving_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_saving_label = /** @type {((inputs?: Explorer_Info_Saving_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Saving_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Enregistrement...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Speichern...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Risparmio...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сохранение...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ahorro...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("保存...")
	if (locale === "ja") return /** @type {LocalizedString} */ ("保存中...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सहेजा जा रहा है...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Salvando...")
	return /** @type {LocalizedString} */ ("Saving...")
});